module.exports = __webpack_public_path__ + "img/logo.08e1a857.png";